// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips":"VanlifeRoadtrips_vanlife-roadtrips__wkaYk"};